export function formatPhoneNumber(phone) {
    return phone.replaceAll('-', '').replaceAll('(', '').replaceAll(')', '')
}
